"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function ManualaddedGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    clipPath: "url(#prefix__manualadded-grey-outline__clip0_14933_7393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.387 4.184H3.585a.597.597 0 01-.423-1.021.597.597 0 01.423-.175h8.802a.597.597 0 01.423 1.021.597.597 0 01-.423.175zM7.468 7.037H3.616a.597.597 0 01-.422-1.022.597.597 0 01.422-.175h3.852a.597.597 0 01.423 1.022.597.597 0 01-.423.175zM11.662 16a3.144 3.144 0 01-2.139-.842l-2.043-1.91a.998.998 0 01-.31-.786v-.096c0-.213.043-.423.127-.618a1.596 1.596 0 011.466-.977c.245.002.486.06.705.171l.139.068V7.316a1.573 1.573 0 011.854-1.423c.29.055.558.19.775.39.295.268.478.639.51 1.037v1.025c.086.026.17.06.25.1.394-.073.801.005 1.14.22.137.086.259.194.362.318a1.557 1.557 0 011.458 1.564v2.294c0 .838-.332 1.641-.924 2.234a3.152 3.152 0 01-2.23.925h-1.14zm-3.298-3.57l1.992 1.855c.362.334.837.52 1.33.518h1.147a1.958 1.958 0 001.96-1.962v-2.294a.435.435 0 00-.032-.155.423.423 0 00-.084-.116.323.323 0 00-.123-.076.28.28 0 00-.14-.024h-.147l-.422.044-.18-.399a.398.398 0 00-.139-.16.354.354 0 00-.342-.027l-.343.151-.286-.24a.335.335 0 00-.3-.071l-.704.1V7.392a.363.363 0 00-.12-.232.398.398 0 00-.51 0 .4.4 0 00-.115.232v5.517l-1.864-.906a.442.442 0 00-.327-.008.475.475 0 00-.131.088.398.398 0 00-.12.283v.064z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.017 4.77a1.196 1.196 0 10-.001-2.39 1.196 1.196 0 00.001 2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.999 15.226H1.593A1.592 1.592 0 010 13.63V1.596A1.597 1.597 0 011.593 0H14.83A1.17 1.17 0 0116 1.173v4.962a.599.599 0 11-1.195 0V1.173l-13.212.024a.398.398 0 00-.398.399v12.043a.4.4 0 00.398.398h3.414a.597.597 0 01.422 1.022.597.597 0 01-.422.175l-.008-.008z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__manualadded-grey-outline__clip0_14933_7393"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

ManualaddedGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
ManualaddedGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = ManualaddedGreyOutline;
exports["default"] = _default;